import React, { useState, useMemo } from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  Box,
  Tabs,
  Tab,
} from '@mui/material'
import {
  Search as SearchIcon,
  ArrowUpward as ArrowUpwardIcon,
  ArrowDownward as ArrowDownwardIcon,
} from '@mui/icons-material'
import { useAuth } from '../../Auth/AuthProvider';
import { useNavigate } from 'react-router-dom';
import { PermissionListAPI } from '../../Conections/RolesAndPermissionsConection';
import { can } from '../../Conections/LogConections';


const initialData = [
  { id: 0, name: '' },
]

export default function ListPermissions() {

  const auth = useAuth();
  const goTo = useNavigate();

  const [data, setData] = useState(initialData);
  const [value, setValue] = useState(0);
  const [description, setDescription] = useState("Empty");
  const [datapermissions, setDatapermissions] = useState(null);
  const [sortConfig, setSortConfig] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);

  React.useEffect(() => {
    reloaduser();
  }, []);

  async function reloaduser() {
    if (auth.getToken()) {
      const permisionCan = await can(auth.getToken(), auth.getCompany(), "/dashboard/rpp/listpermissions");
      if(permisionCan){
        const datos = await PermissionListAPI(auth.getToken(), auth.getCompany());
        setDatapermissions(datos);
        changeTable(0);
      }
      else
      {
        goTo("/dashboard");
      }
    }
    else {
      goTo("/login");
    }
  }

  const sortData = (key) => {
    let direction = 'asc'
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc'
    }
    setSortConfig({ key, direction })
  }

  const sortedAndFilteredData = useMemo(() => {
    let sortableData = [...data]
    if (searchTerm) {
      sortableData = sortableData.filter(
        item =>
          item.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.phone.includes(searchTerm) ||
          item.address.toLowerCase().includes(searchTerm.toLowerCase())
      )
    }
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? -1 : 1
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === 'asc' ? 1 : -1
        }
        return 0
      })
    }
    return sortableData
  }, [data, sortConfig, searchTerm])

  const handleChange = (event, newValue) => {
    setValue(newValue);
    changeTable(newValue);
  };

  function changeTable(index) {
    if (datapermissions !== null) {
      setDescription(datapermissions[index].description);
      setData(datapermissions[index].permissions);
    }
  }

  return (
    <Paper sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ p: 3, flexGrow: 0 }}>
        <Typography variant="h4" gutterBottom color="primary">
          List Permissions
        </Typography>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
            {datapermissions ?
              (datapermissions.map((section, index) => (
                <Tab label={section.name} key={index} />
              ))
              ) : (
                <Tab label="" />
              )
            }
          </Tabs>
        </Box>
      </Box>
      <Box sx={{ p: 3, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        <Typography>
          {description}
        </Typography>
        <Box sx={{ mb: 2, display: 'flex', alignItems: 'flex-end' }}>
          <SearchIcon sx={{ color: 'action.active', mr: 1, my: 0.5 }} />
          <TextField
            label="Buscar"
            variant="standard"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            fullWidth
          />
        </Box>
        <TableContainer component={Paper} sx={{ flexGrow: 1, overflow: 'auto' }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {['name'].map((key) => (
                  <TableCell
                    key={key}
                    onClick={() => sortData(key)}
                    sx={{ cursor: 'pointer' }}
                  >
                    {key.charAt(0).toUpperCase() + key.slice(1)}
                    {sortConfig?.key === key && (
                      sortConfig.direction === 'asc' ? <ArrowUpwardIcon fontSize="small" /> : <ArrowDownwardIcon fontSize="small" />
                    )}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {sortedAndFilteredData.map((person) => (
                <TableRow
                  key={person.id}
                  onClick={() => setSelectedPerson(person)}
                  selected={selectedPerson?.id === person.id}
                  hover
                >
                  <TableCell>{person.name}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Paper>
  )
}